<nav class="navbar navbar-expand-lg navbar-light header-navbar navbar-fixed {{transparentBGClass}}"
  [ngClass]="{'navbar-brand-center': menuPosition === 'Top', 'navbar-static': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Static' , 'navbar-sticky': menuPosition === 'Side' &&
  config?.layout.navbar.type === 'Fixed', 'fixed-top': isSmallScreen && menuPosition === 'Top','app-sidebar': !isSmallScreen}" data-active-color="white"
  [attr.data-background-color]="config?.layout.variant === 'Transparent' ? 'black': bgColor">
  <div class="container-fluid navbar-wrapper">
    <div class="navbar-header d-flex">
      <div class="navbar-toggle menu-toggle d-xl-none d-block float-left align-items-center justify-content-center"
        data-toggle="collapse" (click)="toggleSidebar()">
        <em class="ft-menu font-medium-3"></em>
      </div>
      <ul class="navbar-nav" (clickOutside)="toggleSearchOpenClass(false)">
        <li class="nav-item mr-2 d-none d-lg-block">
          <a class="nav-link apptogglefullscreen" id="navbar-fullscreen" appToggleFullscreen (click)="ToggleClass()"><em
              class="{{toggleClass}} font-medium-3"></em></a>
        </li>
        <li class="nav-item nav-search">
          <a class="nav-link nav-link-search" id="navbar-search" href="javascript:"
            (click)="toggleSearchOpenClass(true)" (click)="searchUrlandName()"><em
              class="ft-search font-medium-3"></em></a>
          <div class="search-input {{searchOpenClass}}">
            <div class="search-input-icon">
              <em class="ft-search font-medium-3 " id="cross"></em>
            </div>
            <input [formControl]="control" #search class="input" type="text" id="searchMenu"
              placeholder="Explore Vidyalaya Booking..." autofocus data-search="template-search"
              [appAutocomplete]="autocomplete" (keyup.enter)="onEnter()" (keydown.esc)="onEscEvent()"
              (keyup)="onSearchKey($event)" />
            <div class="search-input-close" (click)="toggleSearchOpenClass(false)">
              <em class="ft-x font-medium-3"></em>
            </div>
            <app-autocomplete #autocomplete="appAutocomplete">
              <ng-template appAutocompleteContent>
                <ng-container *ngIf="(listItems | filter: control?.value) as result">
                  <app-option #searchResults *ngFor="let option of result" [url]="option?.url" [value]="option?.name"
                    (click)="redirectTo(option?.url);" (mouseenter)="removeActiveClass()">
                    <div class="d-flex align-items-center justify-content-between w-100">
                      <div class="d-flex align-items-center justify-content-start">
                        <em class="{{option.icon}} mr-2"></em>
                        <span>{{ option.name }}</span>
                      </div>
                    </div>
                  </app-option>
                  <app-option class="no-result" *ngIf="!result.length">No results found.</app-option>
                </ng-container>
              </ng-template>
            </app-autocomplete>
          </div>
        </li>

        <li class="d-none d-md-flex">
          <a class="nav-link d-flex align-items-center no-pointer dropdown-language organization" id="dropdown-flag">
            <span class="selected-language d-md-flex ">{{orgDisplayTitle}}</span></a>
        </li>

        <li class="d-none d-md-flex">
          <a class="nav-link d-flex align-items-center no-pointer dropdown-language organization" id="dropdown-flag">
            <span class="selected-language d-md-flex ">{{batchTitle}}</span></a>
        </li>

      </ul>
      <div class="navbar-brand-center">
        <div class="navbar-header">
          <ul class="navbar-nav">
            <li class="nav-item">
              <div class="logo">
                <a class="logo-text" [routerLink]="['/']" *ngIf="config?.layout?.menuPosition === 'Top'">
                  <div class="logo-img"><img class="img-fluid" alt="Vidyalaya logo" [src]="logoUrl">
                  </div>
                  <span class="text">Vidyalaya</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="navbar-header d-flex">
      <div class="collapse navbar-collapse" [ngClass]="isSmallScreen ?'d-none': 'd-block'" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="dropdown nav-item mr-1 " placement="bottom-left" display="static"> </li>
          <li class="dropdown nav-item mr-1 " placement="bottom-left" display="static">
            {{dashboardUsername}}
          </li>


          <li *ngFor="let item of navbarLinkData">
            <a (click)="fnLink(item.type)" [title]="item.type" class="nav-link nav-link-search">
              <em class="font-medium-3" [ngClass]="item.iconName"> </em>
            </a>
          </li>

        </ul>
      </div>

    </div>

    <!-- Mobile Navbar -->
    <!-- <div class="navbar-container navbarMobile">
      <div class="collapse navbar-collapse d-block" id="navbarSupportedContent">
        <ul class="navbar-nav">

          <li ngbDropdown>
            <a class="nav-link align-items-center text-dark dropdown-language d-flex align-items-end batchDp"
              id="dropdown-flag" href="javascript:;" data-toggle="dropdown" ngbDropdownToggle><img class="avatar"
                src="assets/img/calender.png" alt="avatar" height="30" width="30" /></a>
            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdown-flag">
              <a class="dropdown-item DropDownitem">
                <span class="font-small-3">{{batchTitle}} </span>
              </a>
            </div>
          </li>

          <li ngbDropdown>
            <a class="nav-link align-items-center text-dark dropdown-language d-flex align-items-end organizationDp"
              id="dropdown-flag" href="javascript:;" data-toggle="dropdown" ngbDropdownToggle><img class="avatar"
                src="assets/img/calender.png" alt="avatar" height="30" width="30" /></a>
            <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdown-flag">
              <a class="dropdown-item DropDownitem">
                <span class="font-small-3">{{orgDisplayTitle}} </span>
              </a>
            </div>
          </li>

          <li ngbDropdown>
            <a class="nav-link d-flex align-items-center  text-dark dropdown-language d-flex align-items-end"
              id="dropdown-flag" href="javascript:;" data-toggle="dropdown" ngbDropdownToggle><img class="avatar"
                src="assets/img/VidyalayaLogo.png" alt="avatar" height="30" width="30" /><span
                class="dashboardUsername px-1 d-md-flex d-none">{{dashboardUsername}}</span></a>
            <div ngbDropdownMenu class="dropdown-menu text-left " aria-labelledby="dropdown-flag">
              <a class="dropdown-item DropDownitem" href="javascript:;" *ngFor="let link of navbarLinkData"
                (click)="fnLink(link.type)">
                <div class="d-flex align-items-center"><em class="langimg font-medium-3" [ngClass]="link.iconName"></em>
                  <span class="font-small-3">{{ link.type }}</span>
                </div>
              </a>
            </div>
          </li>

          <li class="nav-item d-none d-lg-block mr-2 mt-1">
            <a class="nav-link notification-sidebar-toggle" href="javascript:;">
              <i class="ft-align-right font-medium-3"></i></a>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</nav>

<ng-template #HelperModel let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-12">
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">
            <em class="ft-x text-danger"></em>
          </span>
        </button>
      </div>
    </div>
    <div class="modal-body" *ngIf="helperPopUp">
      <div [innerHTML]="helpPopUp"></div>
    </div>
  </div>
</ng-template>

<ng-template #DependencyModel let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-12">
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">
            <em class="ft-x text-danger"></em>
          </span>
        </button>
      </div>
    </div>
    <div class="modal-body" *ngIf="dependencyPopUp">
      <div [innerHTML]="dependencypopUp"></div>
    </div>
  </div>
</ng-template>